import PropTypes from 'prop-types';

import { RMask } from 'components/RMask';
import { RPopupStyled } from './styled';

RPopup.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  css: PropTypes.any,
  maskCss: PropTypes.any,
  popupPosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
};

function RPopup({
  css,
  color = 'rgba(9, 7, 11, 0.32)',
  maskCss,
  popupPosition = { x: 0, y: 0 },
  children,
}) {
  return (
    <RMask
      color={color}
      css={maskCss}
    >
      <RPopupStyled
        popupPosition={popupPosition}
        css={css}
      >
        {children}
      </RPopupStyled>
    </RMask>
  );
}

export { RPopup };
